import { MapContainer, TileLayer, Marker } from 'react-leaflet';

/**
 * @description: This is a fictional web platform component,
 *  used only to resolve the react-native-maps -> react-native-web-maps module.
 *  There is no real-world use for this component, only the .web.tsx file.
 */
export default function MapModal(props) {
  return (
    <MapContainer center={props.center} zoom={13}>
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={props.center} />
    </MapContainer>
  );
}
